import { IContentfulComponentsParsersData } from '@utils/contentful/contentfulComponents/pageContent'
import { parseFeaturesList } from '@utils/contentful/contentfulComponents/parsers/parseFeaturesList'
import { parseFeature } from '@utils/contentful/contentfulComponents/parsers/parseFeature'
import { parseInTheWild } from '@utils/contentful/contentfulComponents/parsers/parseInTheWild'
import { parseSpacer } from '@utils/contentful/contentfulComponents/parsers/parseSpacer'
import { parseConfigurableDescriptionList } from '@utils/contentful/contentfulComponents/parsers/parseConfigurableDescriptionList'
import { Entry } from 'contentful'
import { IContentfulFeaturesList } from '../../types/contentful/featuresList'
import { IContentfulFeature } from '../../types/contentful/feature'
import { IContentfulInTheWild } from '../../types/contentful/inTheWild'
import { parseConfigurableCard } from './contentfulComponents/parsers/parseConfigurableCard'
import { parseConfigurableSlider } from './contentfulComponents/parsers/parseConfigurableSlider'
import { parseConfigurableTileList } from './contentfulComponents/parsers/parseConfigurableTileList'
import { parseConfigurableTile } from './contentfulComponents/parsers/parseConfigurableTile'
import { parseMarketingBanner } from './contentfulComponents/parsers/parseMarketingBanner'
import { parseConfigurableEmbed } from './contentfulComponents/parsers/parseConfigurableEmbed'
import { parseConfigurableAccordion } from './contentfulComponents/parsers/parseConfigurableAccordion'

export type TConfigurableListSlot = Entry<
  IContentfulFeaturesList | IContentfulFeature | IContentfulInTheWild
>[]

const contentfulToPropMapper = {
  configurableAccordion: parseConfigurableAccordion,
  noissueFeaturesList: parseFeaturesList,
  noissueFeature: parseFeature,
  productCategoryInTheWild: parseInTheWild,
  noissueSpacer: parseSpacer,
  configurableDescriptionList: parseConfigurableDescriptionList,
  configurableCard: parseConfigurableCard,
  configurableSlider: parseConfigurableSlider,
  configurableTileList: parseConfigurableTileList,
  configurableTile: parseConfigurableTile,
  configurableMarketingBanner: parseMarketingBanner,
  configurableEmbed: parseConfigurableEmbed,
}

export const contentfulPageToComponentsProps = async ({
  contentfulPageComponents,
  dataForParsers,
}: {
  contentfulPageComponents: TConfigurableListSlot
  dataForParsers: IContentfulComponentsParsersData
}) => {
  if (!contentfulPageComponents) {
    return []
  }

  const componentsProps = await Promise.all(
    contentfulPageComponents.map(async (component) => {
      const componentId = component?.sys?.contentType?.sys?.id

      if (!componentId) {
        return null
      }

      if (contentfulToPropMapper[componentId]) {
        const propsForComponent = await contentfulToPropMapper[componentId](
          component,
          dataForParsers
        )
        return propsForComponent
      }

      throw new Error(
        `There is no parser set up for this Content Type ${componentId}`
      )
    })
  )

  return componentsProps.filter(Boolean)
}
